export default __webpack_public_path__ + "static/media/vegan-icon.cf978e54.svg";